export default (qtySelects, callback) => {
  qtySelects.forEach((qtySelect) => {
    const input = qtySelect.querySelector('input');
    const buttons = [...qtySelect.querySelectorAll('button')];
    const itemKey = qtySelect.getAttribute('data-item-key');
    const lineId = qtySelect.getAttribute('data-line-id');

    let matchingInputs;
    if (itemKey) {
      matchingInputs = [
        ...document.querySelectorAll(`.js-quantity-select[data-item-key="${itemKey}"] input`),
      ];
    } else {
      matchingInputs = [input];
    }

    const setInputValue = (value, matchingInputElsArray) => {
      let newValue = value;
      if (input.min && newValue < input.min) {
        newValue = input.min;
      }

      if (input.max && newValue > input.max) {
        newValue = input.max;
      }

      matchingInputElsArray.forEach((inp) => {
        inp.value = newValue;
      });

      if (callback) {
        callback(input, newValue, lineId);
      }
    };

    buttons.forEach((button) => {
      const { increment } = button.dataset;
      button.addEventListener('click', () => {
        const newValue = parseInt(input.value, 10) + parseInt(increment, 10);
        setInputValue(newValue, matchingInputs);
      });
    });

    input.addEventListener('change', () => {
      setInputValue(parseInt(input.value, 10), matchingInputs);
    });
  });
};
